<div cdkDropList (cdkDropListDropped)="onDrop($event)" class="sortable-container drag-boundary">
  @for (item of items; track trackItem($index, item)) {
    <rt-list-sortable-item
      [title]="item.title! || item.name!"
      [item]="item"
      [processing]="(isProcessing$(item) | async)!"
      [renamable]="isAllowedTo('renamable', item)"
      [removable]="isAllowedTo('removable', item)"
      (delete)="delete(item)"
      (nameChange)="nameChanged(item, $event)"
      cdkDrag
      cdkDropListLockAxis="y"
      cdkDragBoundary=".drag-boundary"
    >
    </rt-list-sortable-item>
  }
</div>
